// extracted by mini-css-extract-plugin
export default {"invoiceContainer":"invoiceContaineroH7Ce"};